import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useCancelBulkImport = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	return useMutation(
		async (importId) => {
			const instance = await InitApi({ accessToken });
			const response = await instance.post(
				`/publisher/bulk-book-imports/${importId}/cancel`
			);
			return response.data?.data;
		},
		{
			onSuccess: (_data, importId) => {
				queryClient.invalidateQueries(["bulkBookImport", importId]);
				queryClient.invalidateQueries("bulkBookImports");
				toast.success("Import cancelled");
			},
			onError: (error) => {
				toast.error(
					<ServerErrors
						errorMessage={error?.response?.data?.message}
						errors={error?.response?.data?.data}
					/>
				);
			},
		}
	);
};

export default useCancelBulkImport;
